import React from "react";
import { Formik, Form } from "formik";
import HylyField from "storybookComponents/HylyField";
import { formatNumber } from "storybookComponents/utils";
import SelectDate, { parseDate } from "./selectDate";
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Collapse } from "reactstrap";
import Typography from "storybookComponents/Typography"
import Expansion from "components/Expansion";
import Icon from "storybookComponents/Icon";
import * as apis from "relay/invite";
import { parseDateToString } from "../util";
import Button from 'storybookComponents/Button';
import "./style.css";
import { date } from "yup";

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  formControl: {
    marginTop: 20,
  },
  subField: {
    padding: "0 30px",
    paddingRight: 8,
  },
  subFieldContainer: {
    display: "flex",
    alignItems: "center",
    marginTop: "0.5rem",
  },
  tag: { background: "#F8F8F8", minWidth: 50, textAlign: "center", padding: "2px 0", border: "2px solid white" },
  fieldContainer: {
    position: "relative"
  },
  addButton: {
    color: "rgba(51,51,51,1)",
    width: 191,
    padding: "6px 16px",
    marginTop: 10,
    marginLeft: 27,
    border: "1px solid rgba(153,153,153,1)",
    display: "flex",
    alignContent: "center",
    justifyContent: "space-between"
    // ["&& span"]: {
    //   position: "absolute",
    //   right: 30,
    //   top: 7,
    //   color: "rgba(51,51,51,0.75)",
    // }
  },
  root: {
    "&$checked": {
      color: "red"
    }
  },
  dateAlign: {
    textAlign: "end",

    fontSize: 16
  },
  hrLine: {
    width: 580,
    height: 1,
    background: "#EEEEEE",
    margin: "20px 0px"
  },
  scheduleButton: {
    height: 40,
    marginTop: 24,
    textTransform: "none",
    width: 150,
    marginBottom: 8
  },
  displayFlexIcons: {
    display: "flex",
    alignItems: "end",
    justifyContent: "flex-end",
    width: "max-content",
  },
  sentSuccess: {
    color: "#66D184",
    fontWeight: "bold",
    marginRight: 12,
    marginLeft: 12
  },
  dateMargin: {
    marginBottom: 12,
  },
  brokersList: {
    fontSize: 14,
    textAlign: "end",
  },
}));


const Tag = ({ children }) => {
  const classes = useStyles();
  return <div className={classes.tag}>{children}</div>
}

const Invitee = ({ data, selected, onChange }) => {

  const [open, setOpen] = React.useState(false);

  const classes = useStyles();

  const handleChange = (evt) => {
    setOpen(evt.target.checked);
    onChange(`${data.name} (${data.reachableCount})`, evt.target.checked, data)
  }
  return (
    <div>
      <div id="CheckField" className={classes.subFieldContainer}>
        <FormControlLabel
          control={<Checkbox color="primary" onChange={handleChange} name={data.name} defaultChecked={selected.indexOf(`${data.name} (${data.reachableCount})`) > -1} />}
          label={data.name}
        />
        <Tag absolute >{data.count}</Tag>
      </div>
      <Collapse isOpen={open}>
        <div className={classes.subFieldContainer}>
          <Typography className={classes.subField}>- Events reachable </Typography>
          <Tag>{data.reachableCount}</Tag>
        </div>
        {
          data.mmsReachableCount ?
            <div className={classes.subFieldContainer}>
              <Typography className={classes.subField}>- SMS reachable </Typography>
              <Tag>{data.mmsReachableCount}</Tag>
            </div>
            : null
        }
      </Collapse>
    </div>
  )
}



export const Invitees = ({
  setFieldValue,
  values,
  propertyId,
  expanded,
  name,
  handleExpandedPanel,
  prevDate,
  invitedGroups,
  getSubmitButtonState,
  onScheduleSMSEmail
}) => {

  const classes = useStyles();
  const [selected, setSelected] = React.useState([])
  const [date, setDate] = React.useState("");
  const [contactGroups, setContactGroups] = React.useState([]);
  const [allResidence, setAllResidence] = React.useState();
  React.useEffect(() => {

    loadContactGroups();

  }, [1])

  const loadContactGroups = async () => {
    try {
      const res = await apis.getContactGroups(propertyId);
      if (res.contactGroups) {
        let allResidence = res.contactGroups.find(i => i.name == "Resident");
        setAllResidence(allResidence)
        // let raw = []
        // let _selected = invitedGroups ? JSON.parse(invitedGroups) : []

        // for (let i = 0; i < res.contactGroups.length; i++) {
        //   if (_selected.indexOf(res.contactGroups[i].name) > -1) {
        //     raw.push(res.contactGroups[i])
        //   }
        // }
        // setSelected(raw.map(data => `${data.name} (${data.reachableCount})`));
        // setContactGroups(res.contactGroups);
      }

    }
    catch (err) {
      console.log("contact group load error : ", err)
    }

  }


  const onChange = (data, checked, obj) => {
    setSelected(checked ? [...selected, data] : selected.filter(i => i !== data));
    if (setFieldValue) {
      setFieldValue("invitedGroups", checked ? [...values.invitedGroups, obj.name] : values.invitedGroups.filter(i => i !== obj.name))
    }
  }

  const renderCheckBox = (data, index) => (
    <Invitee data={data} key={index} onChange={onChange} selected={selected} />
  )

  const rightSectionContent = () => (
    <div>
      <div className={`${classes.displayFlexIcons} ${classes.dateMargin}`}>
        {
          prevDate ? <Icon type=" icon-n-check" className={classes.sentSuccess} /> : null
        }
        {(date || prevDate) ? <div className={classes.dateAlign}>{date ? date : prevDate ? parseDateToString(prevDate) : ""}</div> : null}
      </div>
      <div className={classes.brokersList}>{allResidence ? allResidence.count > 1 ? `Residents(${allResidence.count})` : `Resident(${allResidence.count})` : null}</div>
    </div>
  )


  return (
    <Expansion
      expanded={expanded}
      name={name}
      handleExpandedPanel={handleExpandedPanel}
      header="Schedule Invite"
      headerIcon={open => prevDate && open ? <Icon type=" icon-n-check" className={classes.sentSuccess} /> : null}
      subtitle={`Set a date to send referral camgaign invites to all the <b>Residents (${allResidence && allResidence.count})</b>`}
      rightSection={open => !open ? rightSectionContent() : ""}
    >

      <Form>
        <FormControl component="fieldset" className={classes.formControl}>
          <FormGroup>
            {/* {contactGroups.map(renderCheckBox)} */}
            <SelectDate keyName="inviteScheduleAt" defaultValue={prevDate || ""} setDate={setDate} setFieldValue={setFieldValue} />
          </FormGroup>
          <Button className={classes.scheduleButton} onClick={onScheduleSMSEmail} state={getSubmitButtonState()} size="sm">Schedule Invite</Button>
        </FormControl>
      </Form>
    </Expansion>
  )
}
